export const USER_UNAUTHORIZED = `You are not authorized for this application. Please contact the Help Desk for assistance.`